import {Component, Input} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@Component({
    selector: 'app-adx-booking-hotel-info',
    templateUrl: './adx-booking-hotel-info.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class AdxBookingHotelInfoComponent {
  @Input() data: any;
  get hotelExtension(): any {
    return this.data ?? {};
  }
  get hotelProperty(): any {
    return this.hotelExtension?.hotelProperty ?? {};
  }
}
